import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { setHistoryNavigation } from 'src/actions/navigationActions';

function AuthGuard({ children }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const account = useSelector(state => state.account);

  if (!account.user) {
    dispatch(setHistoryNavigation(location.pathname));
    return <Redirect to="/login" />;
  }

  if (account.user?.type !== 'cigam') {
    return <Redirect to="/" />;
  }

  return children;
}

AuthGuard.propTypes = {
  children: PropTypes.oneOfType([PropTypes.elementType, PropTypes.object]),
};

export default AuthGuard;
